import { render } from "./StockWatch.vue?vue&type=template&id=f61db740&scoped=true"
import script from "./StockWatch.vue?vue&type=script&lang=js"
export * from "./StockWatch.vue?vue&type=script&lang=js"

import "./StockWatch.vue?vue&type=style&index=0&id=f61db740&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61db740"]])

export default __exports__